import React from 'react';
import {FormattedMessage} from 'react-intl';
import {INSTAGRAM_CHANNEL, TIKTOK_CHANNEL, TELEGRAM_CHANNEL} from '../../constants';
import {LinkButton} from '../button/button';
import InstagramIcon from '../../assets/instagram.svg';
import TiktokIcon from '../../assets/tiktok.svg';
import TelegramIcon from '../../assets/telegram.svg';
import './cta-socials.scss';

const CtaSocials = () => {
    return (
        <div className='cta-socials display-flex flex-direction-column align-items-center padding-left-1rem padding-right-1rem padding-top-1dot75rem padding-bottom-1dot75rem border-radius-1rem background-color-white'>
            <div className='text-xl medium color-gray-700'>
                <FormattedMessage defaultMessage='Subscribe'/>
            </div>
            <div className='padding-top-0dot5rem text-md color-gray-500 text-align-center'>
                <FormattedMessage defaultMessage='Find out when your favorite artist is performing' />
            </div>
            <div className='padding-top-1dot5rem display-flex column-gap-1dot5rem'>
                <LinkButton {...{plain: true, color: 'custom', link:{target: '_blank', rel: 'noopener noreferrer', href: INSTAGRAM_CHANNEL}}}>
                    <InstagramIcon className=''/>
                </LinkButton>
                <LinkButton {...{plain: true, color: 'custom', link:{target: '_blank', rel: 'noopener noreferrer', href: TIKTOK_CHANNEL}}}>
                    <TiktokIcon className=''/>
                </LinkButton>
                <LinkButton {...{plain: true, color: 'custom', link:{target: '_blank', rel: 'noopener noreferrer', href: TELEGRAM_CHANNEL}}}>
                    <TelegramIcon className=''/>
                </LinkButton>
            </div>
        </div>
    );
};

export default React.memo(CtaSocials);